// Codes are persisted by Injury V2. A rendering/view change must never change them.
const paired = (part, labelDe, labelEn, surface = "both") => [
  { code: `left_${part}`, labelDe: labelDe[0], labelEn: `Left ${labelEn}`, surface, side: "left" },
  { code: `right_${part}`, labelDe: labelDe[1], labelEn: `Right ${labelEn}`, surface, side: "right" },
];

export const BODY_REGIONS = [
  { code: "head", labelDe: "Kopf", labelEn: "Head", surface: "both", side: null },
  { code: "neck", labelDe: "Nacken / Hals", labelEn: "Neck", surface: "both", side: null },
  ...paired("shoulder", ["Linke Schulter", "Rechte Schulter"], "shoulder"),
  { code: "chest", labelDe: "Brust", labelEn: "Chest", surface: "front", side: null },
  { code: "upper_back", labelDe: "Oberer Rücken", labelEn: "Upper back", surface: "back", side: null },
  { code: "lower_back", labelDe: "Unterer Rücken", labelEn: "Lower back", surface: "back", side: null },
  { code: "abdomen", labelDe: "Bauch", labelEn: "Abdomen", surface: "front", side: null },
  ...paired("hip", ["Linke Hüfte", "Rechte Hüfte"], "hip"),
  ...paired("groin", ["Linke Leiste", "Rechte Leiste"], "groin", "front"),
  ...paired("upper_arm", ["Linker Oberarm", "Rechter Oberarm"], "upper arm"),
  ...paired("elbow", ["Linker Ellenbogen", "Rechter Ellenbogen"], "elbow"),
  ...paired("forearm", ["Linker Unterarm", "Rechter Unterarm"], "forearm"),
  ...paired("hand", ["Linke Hand / Handgelenk", "Rechte Hand / Handgelenk"], "hand / wrist"),
  ...paired("thigh_front", ["Linker Oberschenkel (vorne)", "Rechter Oberschenkel (vorne)"], "thigh (front)", "front"),
  ...paired("thigh_back", ["Linker Oberschenkel (hinten)", "Rechter Oberschenkel (hinten)"], "thigh (back)", "back"),
  ...paired("knee", ["Linkes Knie", "Rechtes Knie"], "knee"),
  ...paired("shin", ["Linkes Schienbein", "Rechtes Schienbein"], "shin", "front"),
  ...paired("calf", ["Linke Wade", "Rechte Wade"], "calf", "back"),
  ...paired("ankle", ["Linkes Sprunggelenk", "Rechtes Sprunggelenk"], "ankle"),
  ...paired("foot", ["Linker Fuß", "Rechter Fuß"], "foot"),
  { code: "other", labelDe: "Andere / nicht eindeutig", labelEn: "Other / not sure", surface: "both", side: null },
];

const byCode = new Map(BODY_REGIONS.map((region) => [region.code, region]));

// Empty labels/surfaces keep unknown and pre-V2 historical values unlabelled.
export function bodyRegionLabel(code, lang = "de", surface) {
  const region = byCode.get(code);
  // Presentation alias only. Legacy hip codes are intentionally not reclassified;
  // without explicit view context, records keep their existing canonical label.
  if (surface === "back" && (code === "left_hip" || code === "right_hip")) {
    return lang === "en" ? `${region.side === "left" ? "Left" : "Right"} gluteal muscles`
      : `Gesäßmuskulatur ${region.side === "left" ? "links" : "rechts"}`;
  }
  return region ? region[lang === "en" ? "labelEn" : "labelDe"] : "";
}

export function bodyRegionSurface(code) {
  return byCode.get(code)?.surface ?? null;
}
